import { Badge } from 'reactstrap';
import { useFixturesMode } from '../api/fixtures';

/**
 * Visueller Indicator wenn `VITE_USE_FIXTURES=1` aktiv ist.
 *
 * Lebt im AppHeader. Verhindert dass Operator versehentlich Settings im
 * Fixture-Mode "speichern" und dann denken die wären persistent — Mock-DB
 * lebt nur im Tab-Memory (window.__ORBIT_*_DB__).
 */
export function FixtureModeBadge() {
  const isFixture = useFixturesMode();
  if (!isFixture) return null;
  return (
    <Badge
      color="warning"
      pill
      className="me-2"
      title="VITE_USE_FIXTURES=1 — alle Daten sind Mocks, Mutationen leben nur im Tab"
    >
      🧪 Fixture-Mode
    </Badge>
  );
}
